import {
    Grid,
} from "@mui/material";
import CustomBreadCrumbs from "components/CustomBreadCrumbs";
import { useDocumentsPage } from "hooks/useDocumentsPage";
import DocumentsTable from "../components/DocumentsTable";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { smx3 } from "slices/categoriesActions";
import { useAppDispatch } from "utilities/hooks";

const DefaultDocumentsPage = () => {
    const {
        currentTeam,
        breadcrumbs,
        loading,
        navigateTo,
    } = useDocumentsPage();

    const dispatch = useAppDispatch();
    const [searchParams] = useSearchParams();
    const smxId = searchParams.get('smxId');

    useEffect(() => {
        (async () => {
            if (smxId) {
                const res = await dispatch(smx3(smxId));
                if (res.payload) {
                    navigateTo(res.payload);
                }
            }
        })();
    }, [smxId]);

    if (smxId) {
        return <div>Loading...</div>;
    }

    return (
        <>
            <Grid item xs={8} sx={{ pb: 2 }}>
                <CustomBreadCrumbs
                    title='Documents'
                    loading={loading}
                    breadcrumbs={breadcrumbs}
                    onRootClick={() => {
                        navigateTo();
                    }}
                    onClick={(breadcrumb) => {
                        navigateTo(breadcrumb.id);
                    }}
                />
            </Grid>

            <DocumentsTable hasFileTree={true} />
        </>
    );
};

export default DefaultDocumentsPage;
